import React, { useEffect, useState } from "react";
import {
  AdminViewAllOrders,
  GetAllCarts,
  SendBulkEmails,
  SendEmail,
} from "../utils/Api/ApiCalls";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";

const Cart = () => {
  const [cartData, setCartData] = useState([]);
  const [orderData, setOrderData] = useState([]);
  const [pendingData, setPendingData] = useState([]);
  const itemsPerPage = 5;
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [isSending, setIsSending] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [temp, setTemp] = useState([]);

  const [loading, setLoading] = useState(false);

  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);
  const [c, setC] = useState(0);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % cartData.length;
    setItemOffset(newOffset);
  };

  function removeDuplicateEmails(data) {
    const seenEmails = new Set();
    const uniqueData = [];

    for (const item of data) {
      if (item.email) {
        const email = item.email;
        if (!seenEmails.has(email)) {
          seenEmails.add(email);
          uniqueData.push(item);
        }
      } else {
        uniqueData.push(item); // or you can skip it: //continue;
      }
    }

    return uniqueData;
  }

  useEffect(() => {
    fetchingOrders();
    getCarts();
  }, []);

  const fetchingOrders = async () => {
    try {
      const response = await AdminViewAllOrders();
      const pendingOrders = response?.data?.filter(
        (order) => order.status.toLowerCase() === "pending"
      );

      setOrderData(pendingOrders);

      // setPendingData(removeDuplicateEmails(pendingOrders));
      setPendingData(pendingOrders);
    } catch (err) {
    Swal.fire({ icon: "error", title: "Error", text: err?.response?.data?.message || err?.message || "An error occurred" });
    return err;
  }
  };

  const getCarts = async () => {
    try {
      const cartsData = await GetAllCarts();
      setCartData(cartsData?.carts);

      setPendingData((prev) => {
        return [...prev, cartsData?.carts];
      });
    } catch (err) {
    Swal.fire({ icon: "error", title: "Error", text: err?.response?.data?.message || err?.message || "An error occurred" });
    return err;
  }
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    // Filter in real time as the user types
    // const filteredData = pendingData.filter(
    //   (item) =>
    //     item?.user?.fullname?.toLowerCase().includes(value.toLowerCase()) ||
    //     item?.customerName?.toLowerCase().includes(value.toLowerCase()) ||
    //     item?.customerEmail?.toLowerCase().includes(value.toLowerCase())
    // );

    // setPendingData(filteredData);
  };

  const filteredData = pendingData.filter(
    (item) =>
      item?.user?.fullname?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item?.customerName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item?.customerEmail?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const endOffset = itemOffset + itemsPerPage;
  const pageCount = Math.ceil(filteredData?.length / itemsPerPage);
  let currentItems = filteredData?.slice(itemOffset, endOffset);

  const sendEmail = async (email) => {
    if (!email) return;
    setLoading(true);
    try {
      const res = await SendEmail(email);
        Swal.fire({
          icon: "success",
          title: "Succesful",
          text: `Email sent to ${email}`,
        });
        setLoading(false);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Something went wrong",
      });
      setLoading(false);
    }
  };

  const sendBulkEmail = async () => {
    setIsSending(true);
    try {
      const res = await SendBulkEmails();
        Swal.fire({
          icon: "success",
          title: "Succesful",
          text: `Emails sent to all users.`,
        });
        setIsSending(false);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Something went wrong",
      });
      setIsSending(false);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <section class="content-main">
      <div class="content-header">
        <h2 class="content-titule">Pending carts</h2>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <header class="border-bottom mb-4 pb-4">
                <div class="row">
                  <div class="col-lg-5 col-6 me-auto">
                    <input
                      type="text"
                      placeholder="Search by Name..."
                      class="form-control"
                      value={searchTerm}
                      onChange={handleSearchChange}
                      // onKeyUp={onSearch}
                    />
                  </div>
                  <div className="col-lg-5 col-auto me-auto">
                    <button
                      className="btn btn-sm btn-success mt-3"
                      onClick={sendBulkEmail}
                      disabled={isSending}
                    >
                      {isSending ? "Sending..." : "Send Bulk Email"}
                    </button>
                  </div>
                </div>
              </header>

              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>Customer Name</th>
                      <th>Email</th>
                      <th>Phone Number</th>
                      <th>Created Date</th>
                      <th>Actions</th>
                      {/* <th class="text-end">Action</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems?.length > 0 ? (
                      currentItems?.map((item, i) => (
                        <tr key={"request x" + i}>
                          <td>
                            <b>{item?.user?.fullname || item?.customerName}</b>
                          </td>
                          <td>
                            {" "}
                            {item?.userProfile?.email ||
                              item?.customerEmail}{" "}
                          </td>
                          <td>
                            {/* <div class='icontext'>
													<img
														class='icon border'
														src='assets/imgs/card-brands/1.png'
														alt='Payment'
													/>
													<span class='text text-muted'>{item.PaymentMethod}</span>
												</div> */}
                            {item?.user?.phoneNum || item?.phoneNum}
                          </td>
                          <td>
                            {new Date(
                              item.dateAdded || item?.createdDate
                            ).toDateString()}
                          </td>
                          <td>
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={() => {
                                setC(i);
                                sendEmail(
                                  item?.user?.userProfile?.email ||
                                    item?.customerEmail
                                );
                              }}
                              disabled={loading}
                            >
                              {loading && c === i ? "Sending..." : "Send Email"}
                            </button>
                          </td>
                          {/* <td class="text-end">
                            <Link
                              to={`/transaction/details/${item.TransactionId}`}
                              class="btn btn-sm btn-light font-sm rounded"
                            >
                              Details
                            </Link>
                          </td> */}
                        </tr>
                      ))
                    ) : (
                      <tr>No Pending carts</tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pagination-area mt-30 mb-50">
        <nav aria-label="Page navigation example">
          <ReactPaginate
            nextLabel="Next"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            pageCount={pageCount}
            previousLabel="Previous"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link w-auto"
            nextClassName="page-item"
            nextLinkClassName="page-link w-auto"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination justify-content-start"
            activeClassName="active"
            renderOnZeroPageCount={null}
          />
        </nav>
      </div>
    </section>
  );
};

export default Cart;

const toProperCase = (text) => {
  return text.charAt(0).toUpperCase() + text.substr(1).toLowerCase();
};
